import React from "react";

// Import images
import PYTHON_TECH from "../images/tech/python.png";
import DJANGO_TECH from "../images/tech/django.png";
import NUMPY_TECH from "../images/tech/numpy.png";
import PANDAS_TECH from "../images/tech/pandas.png";
import TENSORFLOW_TECH from "../images/tech/tensorflow.png";
import NODEJS_TECH from "../images/tech/nodejs.png";
import ANGULARJS_TECH from "../images/tech/angularjs.png";
import REACT_TECH from "../images/tech/react.png";
import HTMLCSSJS_TECH from "../images/tech/htmlcssjs.png";
import BOOTSTRAP_TECH from "../images/tech/bootstrap.png";
import FLUTTER_TECH from "../images/tech/flutter.png";
import JAVA_TECH from "../images/tech/java.png";
import ANDROIDSTUDIO_TECH from "../images/tech/androidstudio.png";
import MYSQL_TECH from "../images/tech/mysql.png";
import POSTGRES_TECH from "../images/tech/postgres.png";
import FIREBASE_TECH from "../images/tech/firebase.png";
import UBUNTU_TECH from "../images/tech/ubuntu.png";
import R_TECH from "../images/tech/r.png";
import ADOBEXD_TECH from "../images/tech/adobexd.png";
import SPRING_BOOT_TECH from "../images/tech/spring-boot.png";
import VITE_TECH from "../images/tech/vite.png";
import MUI_TECH from "../images/tech/mui.png";

// Material-UI Components
import { Box, Grid } from "@mui/material";

// Define technology data
const techImages = [
  { name: "Python", src: PYTHON_TECH },
  { name: "Django", src: DJANGO_TECH },
  { name: "NumPy", src: NUMPY_TECH },
  { name: "Pandas", src: PANDAS_TECH },
  { name: "TensorFlow", src: TENSORFLOW_TECH },
  { name: "Node.js", src: NODEJS_TECH },
  { name: "AngularJS", src: ANGULARJS_TECH },
  { name: "React", src: REACT_TECH },
  { name: "HTML/CSS/JS", src: HTMLCSSJS_TECH },
  { name: "Bootstrap", src: BOOTSTRAP_TECH },
  { name: "Vite", src: VITE_TECH },
  { name: "MUI", src: MUI_TECH },
  { name: "Flutter", src: FLUTTER_TECH },
  { name: "Java", src: JAVA_TECH },
  { name: "Android Studio", src: ANDROIDSTUDIO_TECH },
  { name: "MySQL", src: MYSQL_TECH },
  { name: "PostgreSQL", src: POSTGRES_TECH },
  { name: "Firebase", src: FIREBASE_TECH },
  { name: "Ubuntu", src: UBUNTU_TECH },
  { name: "R", src: R_TECH },
  { name: "Adobe XD", src: ADOBEXD_TECH },
  { name: "Spring Boot", src: SPRING_BOOT_TECH },
];

function Technologies() {
  return (
    <Box
      sx={{
        backgroundColor: "#0f172a", // Dark background
        padding: "2rem",
        borderRadius: "8px",
      }}
    >
      <Box sx={{ mb: 10 }}>&nbsp;</Box>
      <h1
        style={{ color: "white", textAlign: "center", marginBottom: "1.5rem" }}
      >
        Technologies We Work With
      </h1>
      <Box sx={{ mb: 3 }}>&nbsp;</Box>
      <Grid container spacing={3} justifyContent="center">
        {techImages.map((tech, index) => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#1e293b",
                padding: "1rem",
                borderRadius: "8px",
              }}
            >
              <img
                src={tech.src}
                alt={tech.name}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mb: 10 }}>&nbsp;</Box>
    </Box>
  );
}

export default Technologies;
